// Section Blog sur la landing page

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BlogCard } from "@/components/blog";
import { articles } from "@/data/articles";

const LandingBlog = () => {
  // Afficher les 3 derniers articles
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-20 bg-[#0A0A0F] relative overflow-hidden">
      {/* Gradient de fond subtil */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#F59E0B]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#3B82F6]/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.05] border border-white/[0.08] text-xs font-medium text-white/60 mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#F59E0B]" />
            Actualites
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Dernieres actualites
          </h2>
          <p className="text-white/50">
            Conseils pratiques, guides et nouveautes pour optimiser la gestion de vos chantiers BTP.
          </p>
        </div>

        {/* Grille d'articles */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {latestArticles.map((article) => (
            <BlogCard key={article.slug} article={article} />
          ))}
        </div>

        {/* CTA voir tous les articles */}
        <div className="text-center">
          <Button
            variant="outline"
            className="bg-transparent border-white/20 text-white hover:bg-white/[0.05] hover:border-[#F59E0B]/50 gap-2 rounded-xl"
            asChild
          >
            <Link to="/blog">
              Voir tous les articles
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LandingBlog;
